import { useState } from "react"
import axiosInstance from "../../../services/axios-client"
import { toast } from "react-toastify"

const useHomepage = () => {
    const [payload, setPayload] = useState()

    const getActiveHomepage = async() => {
        try {
            let res = await axiosInstance.get(`/auth/announcements/active`)
                if (res.status===200) {
                    setPayload(res.data.data)
                }
        } catch (error) {
            if(error.response){
                toast.error(error?.response?.data?.status?.description)
            } else if(error.message) {
                toast.error(error.message)
            } else{
                toast.error(error)
            }
        }
    }

    return{
        payload,
        getActiveHomepage,
    }
}

export default useHomepage